import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '~~utils/CommonUtils';
import Modal from '~~elements/Modal';
import Button from '~~elements/Button';
import IconCircleChecked from '~~elements/static/IconCircleChecked.svg';
import Multilingual from '../Multilingual';

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const PaymentResult = () => {
  const query = useQuery();

  const [isOpen, setIsOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [shouldWait, setShouldWait] = useState(false);

  // /myorders/plugin?popup=result&result=success&wait=true
  const popup = query.get('popup');
  useEffect(() => {
    const cleanup = () => {
      query.delete('popup');
      query.delete('result');
      query.delete('wait');
    };

    const result = query.get('result');
    const wait = query.get('wait');

    if (!popup) {
      return;
    }

    if (popup !== 'result' || !['success', 'failure'].includes(result)) {
      cleanup();
      return;
    }

    setIsOpen(true);
    setIsSuccess(result === 'success');
    setShouldWait(wait === 'true');
    cleanup();
  }, [query, popup]);

  const toClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal.Modal isOpen={isOpen} onClickBack={toClose} outterClickBack={false}>
      <Modal.ModalHeader hasBack={false}>付款結果</Modal.ModalHeader>
      <Modal.ModalBody>
        {!isSuccess ? (
          <StyledDiv>
            <span>付款失敗！</span>
            <span>很抱歉，請嘗試重新購買</span>
            <span>（如銀行端已被扣款，請與客服聯絡）</span>
          </StyledDiv>
        ) : (
          <StyledDiv>
            <img src={IconCircleChecked} style={{ width: '2rem', height: '2rem' }} alt="success" />
            <span>付款成功！</span>
            <span>感謝您的支持，已開通相對應服務</span>
            {/* <span>（如服務為人工分析相關，我方將盡速與您聯絡）</span> */}
            {shouldWait && <span>注意：付款流程進行中，如 10 分鐘後仍未開通對應服務請與客服聯絡</span>}
          </StyledDiv>
        )}
      </Modal.ModalBody>
      <Modal.ModalFooter>
        <Button color="transparentWithBorder" onClick={toClose}>
          {Multilingual(`COMMON.CLOSE`)}
        </Button>
      </Modal.ModalFooter>
    </Modal.Modal>
  );
};

export default PaymentResult;
